import RetentionBookingList from './RetentionBookingList';

export default RetentionBookingList;
